import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import maska_r8BHBbSmHt from "/app/plugins/maska.js";
import datadog_client_QilRhoSzJW from "/app/plugins/datadog/datadog.client.js";
import api_QQzOodE9HA from "/app/plugins/api.js";
import balmui_34J0LdUieP from "/app/plugins/balmui.js";
import error_Z9R5b5Ynf8 from "/app/plugins/error.js";
import googleMaps_client_P2I0IWzMrV from "/app/plugins/googleMaps.client.js";
import mixpanel_flxmgVYaFE from "/app/plugins/mixpanel.js";
import nuxtClickAway_sXhCxdw1DZ from "/app/plugins/nuxtClickAway.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  maska_r8BHBbSmHt,
  datadog_client_QilRhoSzJW,
  api_QQzOodE9HA,
  balmui_34J0LdUieP,
  error_Z9R5b5Ynf8,
  googleMaps_client_P2I0IWzMrV,
  mixpanel_flxmgVYaFE,
  nuxtClickAway_sXhCxdw1DZ
]